import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path
            d="M7.8245 3.75969C8.78421 2.08009 11.2056 2.08012 12.1653 3.75969L17.8831 13.7665C18.835 15.4331 17.6316 17.5068 15.7122 17.5068H4.27763C2.35827 17.5068 1.15488 15.4331 2.10673 13.7665L7.8245 3.75969ZM9.99638 13.4325C9.51324 13.4326 9.12147 13.8244 9.12138 14.3075V14.7509C9.12138 15.2341 9.51318 15.6258 9.99638 15.6259C10.4796 15.6259 10.8714 15.2341 10.8714 14.7509V14.3075C10.8713 13.8244 10.4796 13.4325 9.99638 13.4325ZM9.99638 6.22649C9.51324 6.22655 9.12147 6.61835 9.12138 7.10149V10.3642C9.12138 10.8474 9.51318 11.2391 9.99638 11.2392C10.4796 11.2392 10.8714 10.8474 10.8714 10.3642V7.10149C10.8713 6.61832 10.4796 6.22649 9.99638 6.22649Z"
            fill={ds.colorValue.background.danger.strong}
        />
    </Svg>
);

export default SvgComponent;
